module.exports = __webpack_public_path__ + "static/img/guide04.320d260.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/c26/guide04.png
// module id = JL3p
// module chunks = 0